
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { processedUrl } from '@padlet/vivaldi-client'

@Component
export default class ProcessedImage extends Vue {
  @Prop(String) src!: string
  @Prop(Number) width!: number
  @Prop(Number) height!: number
  @Prop(Object) transforms!: { [key: string]: string | number }

  get processedSrc() {
    // For relative urls in development
    if (this.src.startsWith('/')) return this.src

    const purl = processedUrl(this.src, this.transforms)
    return purl
  }

  @Emit('error')
  handleError(error) {
    return error
  }
}
